import { getRandomUniqueColor } from "../../../Dashboard/data_formatter/format-utils";

export const formatTagAnalysisData = (d = []) => {
  try {
    const formattedGraphData = Object.keys(d.graph_data).map((key) => ({
      tag_name: key,
      data: d.graph_data[key],
    }));
    const dataByEntityTag =
      formattedGraphData && formattedGraphData.length ? formattedGraphData : [];

    const entityList = [];
    dataByEntityTag.forEach((tagObj) =>
      entityList.push(...tagObj.data.map((tagObj) => tagObj.topic_name))
    );
    const uniqueEntityList = [...new Set(entityList)];

    const graphColors = getRandomUniqueColor(uniqueEntityList.length);
    let datasets = uniqueEntityList.map((entityName, index) => {
      const data = dataByEntityTag.map((tagObj) => {
        let entityListForTag = tagObj.data;
        let currentEntity =
          (entityListForTag.length &&
            entityListForTag.filter((c) => c.topic_name == entityName)) ||
          [];
        return currentEntity && currentEntity.length
          ? currentEntity[0].count
          : 0;
      });

      return {
        label: entityName,
        data,
        backgroundColor: graphColors[index],
      };
    });
    return {
      labels: dataByEntityTag.map((e) => e.tag_name),
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatTagAnalysisDataByEntity = (d) => {
  try {
    const dataByEntityType =
      d.graph_data && d.graph_data.length ? d.graph_data : [];

    const tagList = [];
    dataByEntityType.forEach((entityObj) =>
      tagList.push(...entityObj.data.map((tagObj) => tagObj.tag_name))
    );
    const uniqueTagList = [...new Set(tagList)];
    const graphColors = getRandomUniqueColor(uniqueTagList.length);
    let datasets = uniqueTagList.map((tagName, index) => {
      const data = dataByEntityType.map((entityObj) => {
        let tagListForEntity = entityObj.data;
        let currentTag =
          (tagListForEntity.length &&
            tagListForEntity.filter((c) => c.tag_name == tagName)) ||
          [];
        return currentTag && currentTag.length ? currentTag[0].count : 0;
      });
      return {
        label: tagName,
        data,
        backgroundColor: graphColors[index],
      };
    });
    return {
      labels: dataByEntityType.map((e) => e.topic_name),
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
